import { makeRequest } from "./client";

export type ApiCourseProgress = {
  courseId: "noticeboard-fundamentals-v1";
  completedLessons: string[];
  completed: boolean;
  finishedOn: string | null;
};

export type ApiCourseCompletion = {
  userId: string;
  accountType: string;
  displayName: string;
  finishedOn: string | null;
};

export type ApiCertification = {
  certificationId: string;
  name: string;
  awardName: string;
  completions: ApiCourseCompletion[];
};

const path = (orgId: string) =>
  `/v1/org/${encodeURIComponent(orgId)}/courses/fundamentals/progress`;

const completionsPath = (orgId: string) =>
  `/v1/org/${encodeURIComponent(orgId)}/courses/completions`;

export const courseProgressApi = {
  get: (orgId: string, token: string) =>
    makeRequest<ApiCourseProgress>(path(orgId), {
      headers: { Authorization: `Bearer ${token}` },
    }),
  save: (orgId: string, token: string, completedLessons: string[], finishedOn?: string) =>
    makeRequest<ApiCourseProgress>(path(orgId), {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify({ completedLessons, ...(finishedOn ? { finishedOn } : {}) }),
    }),
  listCompletions: (orgId: string, token: string) =>
    makeRequest<{ certifications: ApiCertification[] }>(completionsPath(orgId), {
      headers: { Authorization: `Bearer ${token}` },
    }),
};
